/*
 * @AngularClass
 */
export function bootloader(main) {
    switch (document.readyState) {
        case 'loading':
            document.addEventListener('DOMContentLoaded', function () { return main(); });
            break;
        case 'interactive':
        case 'complete':
        default:
            main();
    }
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angularclass/bootloader/esm/index.js
// module id = 341
// module chunks = 0